import React, {Component} from 'react';

import {withRouter} from 'react-router-dom';
import REST from '../Shared/REST';
import '../assets/custom.css';
import Helpers from "../Shared/Helpers";
import RecordRTC from "recordrtc";
import {BUCKET_URL} from "../Shared/Consts";
import lamejs from "lamejs";

import "../assets/students/KidSpeak.css";
import LoadingModal from "../LoadingModalComponent/LoadingModal";
import {Buttons, Buttons1, CountDownComponent, LevelTrackerComponent, VideoComponent} from "./Common";
import ProgressBox from "../ProgressModalComponent/ProgressBox";
import recButton from "../assets/images/rec.gif";
import DialogBox from "../Shared/DialogBox";
import videoInstructionPN from "../assets/images/video_instructions.png";
import InstructionModals from "../Shared/InstructionModals";
import {clearInterval, setInterval} from "timers";
import {updateAppStates, updateStudentAccountTab, updateStudentAppsStatus} from "./actions";
import connect from "react-redux/es/connect/connect";
import {osName} from "react-device-detect";
import TRACKING from "../Shared/DataTrackingPoints";
let sampleRateHz = 48000 //44100;

let hasGetUserMedia = false;
try {
    hasGetUserMedia = !!navigator.getUserMedia ||!!navigator.mediaDevices.getUserMedia || !!navigator.webkitGetUserMedia || !!navigator.mozGetUserMedia || !!navigator.msGetUserMedia;
}
catch(err) {
    hasGetUserMedia = !!navigator.getUserMedia || !!navigator.webkitGetUserMedia || !!navigator.mozGetUserMedia || !!navigator.msGetUserMedia ;
}

let kidspeakTest = `[{
	"id": 371,
	"createdAt": "2018-10-29T09:54:43.471Z",
	"updatedAt": "2018-10-29T09:54:43.471Z",
	"storyStarter": "Frogs live near ponds. They swim in the water. In winter the frogs sleep in the soft mud in the pond. ",
	"title": "Frogs in the Pond",
	"level": 1,
	"version": 21,
	"passageType": "E",
	"deletedAt": null,
	"kidspeak_scores": []
}]`;

let bestScor = `{
	"success": true,
	"body": {
		"id": 6479,
		"userId": 10020,
		"createdAt": "2018-12-26T15:02:15.338Z",
		"updatedAt": "2018-12-26T15:20:52.996Z",
		"mazeLevel": 1,
		"mazeScore": 1,
		"slashLevel": 1,
		"slashScore": 1,
		"ksLevel": 1,
		"ksScore": 1,
		"pnLevel": 1,
		"pnScore": 1,
		"crLevel": 1,
		"crScore": 1,
		"wssLevel": 1,
		"wssScore": 1,
		"kssLevel": 1,
		"kssScore": 1,
		"deletedAt": null
	},
	"msg": ""
}`;

let newSes = `{
	"passageId": 371,
	"AV_FileName": "",
	"sessionTime": 0,
	"startLevel": 1,
	"endLevel": 0,
	"startProgress": 1,
	"endProgress": 0,
	"guid": "5d821dbe-2a2c-43a4-b963-2ec73cc7f735"
}`;

class KidSpeakComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            active: 0,
            loadedScores: false,
            bestScores:{
                ksScore:1,
                ksLevel:1
            }
        };
    }

    async componentDidMount() {
        await Helpers.authorize(this);
        await REST.getBestScores().then(async(response) => {
            if (response.success) {
                await this.setState({
                    loadedScores: true,
                    bestScores:response.body
                });
            }
        });
        await REST.getStudentAppStatus().then(async(res)=>{
            await this.props.updateStudentAppStatus(res.body);
            let {allowedApps, filteredApps, finishedApps} = Helpers.filterApps(this.props.studentUser,this.props.apps);
            await this.props.updateAppStates({
                allowedApps:allowedApps,
                filteredApps:filteredApps,
                finishedApps:finishedApps
            });
            await this.setState({bestScores: res.body.bestScores})
        });
        if(this.props.apps.kidSpeakScores.filter(function(x){return x.gradingDate==null}).length > 3){
            this.props.history.goBack();
        }
    }

    handleActive = (active) => {
        this.setState({active: active});
    };

    handleBeginTest = () => {
        this.setState({active: 3});
    };

    render() {
        return (
            <div className={this.state.active !== 2 ? "bgGrey KidSpeak" : "bgYellow KidSpeak"}>
                {
                    this.state.active === 0 ?
                        <div>
                            <div className="section appSection bgGrey">
                                <div className="container">
                                    <div className="appContainer kidspeak">
                                        <h1 style={{textAlign: "center", fontSize:'42px'}}>KidSpeak</h1>
                                        <div className={"row"} style={{display: "flex", alignItems: "center"}}>
                                            <div className={"col-xs-12 text-center"}>
                                                {
                                                    this.state.loadedScores ?
                                                    <ProgressBox
                                                        appName={"kidspeak"}
                                                        level={this.state.bestScores.ksLevel}
                                                        step={this.state.bestScores.ksScore}
                                                        steps={3}
                                                        maxLevel={12}
                                                        noDescription
                                                    /> : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Buttons appName={"kidspeak"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                        </div>
                        : null
                }
                {
                    this.state.active === 1 ?
                        <div>
                            <div className={"appSection bgGrey"}>
                                <div className="container">
                                    <Buttons1 demo appName={"kidspeak"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                                    <div className="appContainer kidspeak">
                                        <h1 style={{textAlign: "center", fontSize:'42px'}}>KidSpeak: Show Me</h1>
                                        <div className={"row"} style={{display: "flex", alignItems: "center"}}>
                                            <div className={"col-xs-12 centerBlock"}>
                                                <VideoComponent appName={"kidspeak"} url={"https://s3.us-east-2.amazonaws.com/uploaddev/video/kidspeak/Kidspeakgirl2.mp4"}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Buttons appName={"kidspeak"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                        </div>
                        : null
                }
                {
                    this.state.active === 2 ?
                        <div>
                            <Buttons1 practice appName={"kidspeak"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                            <Tutorial studentUser={this.props.studentUser} buttonClick = {this.handleActive} beginTest={this.handleBeginTest}/>
                            <Buttons appName={"kidspeak"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                        </div>
                        : null
                }
                {
                    this.state.active === 3 ?
                        <div>
                            <Buttons1 appName={"kidspeak"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                            <KidSpeak studentUser={this.props.studentUser} buttonClick = {this.handleActive} practice={false} />
                            <Buttons appName={"kidspeak"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                        </div>
                        : null
                }
            </div>
        )
    }
}

class KidSpeak extends Component {

    constructor(props) {
        super(props);
        this.state = {
            popupSurvey: false,
            isUploading:false,
            timerInterval:null,
            timerTime:60,
            countdown: -1,
            bestScores: null,
            countDownTimer: null,
            audioTimeout: null,
            rejectedReason: '',
            recording: false,
            ksPassageSrc: "",
            recordingAudioPlayCount: 0,
            recordingsCount: 0,
            audioSrc: false,
            audioBlob: false,
            recordAudio: null,
            modalDialog: false,
            modalInstruction: false,
            responseContent:'',
            upTime: null,
            disableSubmit: false,
            noMicroPhone: false,
            analytics: {
                type: null,
                metadata: null,
            },
            testMode: false,
            osName: "",
            sampleRateHz: 0,
            sessionData: {
                passageId: 0,
                AV_FileName: "",
                sessionTime: 0,
                startLevel: 0,
                endLevel: 0,
                startProgress: 0,
                endProgress: 0,
                guid: require('uuid/v4')()
            }
        };
        this.handleSurveyBack = this.handleSurveyBack.bind(this);
        this.handleStartKidSpeak = this.handleStartKidSpeak.bind(this);
        this.handleStop = this.handleStop.bind(this);
        this.uploadAudio = this.uploadAudio.bind(this);
        this.requestUserMedia = this.requestUserMedia.bind(this);
        this.startRecord = this.startRecord.bind(this);
        this.stopRecord = this.stopRecord.bind(this);
        this.handleBackToMenu = this.handleBackToMenu.bind(this);
        this.submitSession = this.submitSession.bind(this);
        this.handleRecordStart = this.handleRecordStart.bind(this);
        this.recordingAudioPlay = this.recordingAudioPlay.bind(this);
        this.onUnload = this.onUnload.bind(this);
        this.handleToggleInstruction = this.handleToggleInstruction.bind(this);
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
    }

    onUnload(event) { // the method that will be used for both add and remove event
        event.returnValue = "By leaving or reloading the page you will lose your app progress"
    }

    async componentDidMount() {
        window.addEventListener("beforeunload", this.onUnload);
        Helpers.authorize(this);
        osName === "Mac OS" || osName === "iOS"  ? sampleRateHz = 48000 : sampleRateHz = 44100;
        console.log("OS NAME: "+ osName);
        console.log("sampel rate HZ: " + sampleRateHz);
        this.setState({osName: osName});

        if (!hasGetUserMedia) {
            this.setState({
                modalDialog: true,
                responseContent:!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) && (navigator.userAgent.match('CriOS') || navigator.userAgent.match('Mozilla')) ? 'Please use Safari (above version 11) for this task.' : 'Your browser cannot stream from your webcam. Please switch to Chrome or FireFox.'

            });
            return;
        }
        this.requestUserMedia();
        this.handleStartKidSpeak();
        await this.setState({
            analytics: {
                type: TRACKING.STUDENT_KS_START,
                metadata: {
                    platform: navigator.platform,
                    userAgent: navigator.userAgent
                }
            }
        })
        this.handleAnalytics();
    };

    componentWillUnmount() {
        window.removeEventListener("beforeunload", this.onUnload);
        if (this.state.recording) {
            this.state.recordAudio.stop();
            clearInterval(this.state.countDownTimer);
            clearTimeout(this.state.audioTimeout);
            clearInterval(this.state.timerInterval);
            this.captureUserMedia((stream) => {
                stream.stop();
            });
        }
    }
    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleToggleInstruction= (toggleInstruction) => {
        localStorage.setItem('KidspeakInstruction', toggleInstruction);
    }

    handleBackToMenu(e) {
        this.props.history.goBack();
    }

    requestUserMedia() {
        this.captureUserMedia((stream) => {
            this.setStreamToAudio(stream);
        });
    }

    handleStop(blob) {
        this.setState({
            recording: false,
            audioTimeout: null
        });
        this.releaseStreamFromAudio();
        this.uploadAudio(blob instanceof Blob, blob);
    }

    async encodeMono(channels, sampleRate, samples) {
        let kbps = 256; //encode 128kbps mp3
        let mp3encoder = new lamejs.Mp3Encoder(channels, sampleRate, kbps);
        let sampleBlockSize = 1152; //can be anything but make it a multiple of 576 to make encoders life easier

        let mp3Data = [];
        for (let i = 0; i < samples.length; i += sampleBlockSize) {
            let sampleChunk = samples.subarray(i, i + sampleBlockSize);
            let mp3buf = mp3encoder.encodeBuffer(sampleChunk);
            if (mp3buf.length > 0) {
                mp3Data.push(mp3buf);
            }
        }
        let mp3buf = mp3encoder.flush();   //finish writing mp3

        if (mp3buf.length > 0) {
            mp3Data.push(new Int8Array(mp3buf));
        }
        let blob = new Blob(mp3Data, {type: 'audio/mp3'});
        await this.setState({
            audioBlob: blob
        });
        this.handleStop(blob);
    }

    setStreamToAudio(stream) {
        this.audio.srcObject = stream;
    }

    releaseStreamFromAudio() {
        this.audio.pause();
        this.audio.srcObject = null;
        this.audio.src = "";
        this.audio.load();
    }

    startRecordAudio() {
        this.captureUserMedia((stream) => {
            console.log("start record sample rate HZ:" + sampleRateHz);
            this.setState({sampleRateHz:sampleRateHz});
            let options = {
                type: 'audio',
                audio: this.audio,
                sampleRate: sampleRateHz,
                bufferSize: 4096,
                numberOfAudioChannels: 1,
                recorderType: RecordRTC.StereoAudioRecorder
            };

            this.setState({recordAudio: new RecordRTC.StereoAudioRecorder(stream, options)});
            this.state.recordAudio.record();
            this.handleStartAudio(stream);
        }, {audio: true, video: false});
    }

    handleStopAudio(wavBlob) {
        this.setState({
            recording: false
        });
        let fileReader = new FileReader();
        fileReader.onload = (event) => {
            let arrayBuffer = event.target.result;
            let wav = lamejs.WavHeader.readHeader(new DataView(arrayBuffer));
            let samples = new Int16Array(arrayBuffer, wav.dataOffset, wav.dataLen / 2);
            this.encodeMono(wav.channels, wav.sampleRate, samples);
            this.releaseStreamFromAudio();
        };
        fileReader.readAsArrayBuffer(wavBlob);
    }

    handleStartAudio(stream) {
        
        let timerInterval = setInterval(() => {
            if(this.state.timerTime>0) {
                this.setState({
                    timerTime: this.state.timerTime - 1
                });
            }else{
                clearInterval(this.state.timerInterval);
                this.setState({
                        timerInterval: null
                });
            }
        },1000);

        let timeoutTimer = setTimeout(() => {
            this.stopRecord();
        }, 1000 * 60);

        this.setStreamToAudio(stream);

        this.setState({
            recording: true,
            audioTimeout: timeoutTimer,
            timerInterval:timerInterval,
            timerTime:60
        });
    }

    stopRecordAudio() {
        this.state.recordAudio.stop((wavBlob) => {
            this.handleStopAudio(wavBlob);
        });
    }

    captureUserMedia = (callback, options) => {
        let params = null;
        if (options) {
            params = options;
        } else {
            params = {audio: true, video: false};
        }

        navigator.mediaDevices.getUserMedia(params)
            .then(callback)
            .catch(error => {
                console.log(error);
                this.setState({
                    modalDialog: true,
                    responseContent:'No microphone has been found!',
                    noMicroPhone: true
                });
            });
    };

    async uploadAudio(isBlob, blob) {
        const vidETA = await Helpers.calculateETA(null ,blob);
        this.setState({
            upTime: vidETA
        });
        await this.startTimer();
        await REST.uploadKSAudio(blob).then(async (res) => {
            this.audio2.src = BUCKET_URL + res.body.filepath;
            await this.setState({
                audioSrc: this.audio2.src,
                recordingsCount: this.state.recordingsCount + 1,
                isUploading:false
            });
            this.audio2.load();
            if (this.state.recordingsCount > 1) {
                this.submitSession();
            }
            window.removeEventListener("beforeunload", this.onUnload);
        }).catch(error => {
            console.log(error);
        });
    }

    submitSession() {
        this.setState({
            disableSubmit: true
        })
        let seshData = this.state.sessionData;
        seshData.AV_FileName = this.state.audioSrc.replace(BUCKET_URL, "");
        seshData.sessionTime = 60 - this.state.timerTime;
        if(!this.props.practice) {
            window.removeEventListener("beforeunload", this.onUnload);
            REST.insertKSSession(seshData).then(res => {
                this.setState({
                    modalDialog: true,
                    responseContent:'Data Successfully Saved and Submitted'
                });
                //setTimeout(()=>{this.setState({modalDialog:false, popupSurvey: true}); },2500);

            });
        }
    }

    async handleSurveyBack(){
        //window.location.reload();
        this.props.buttonClick(0)
    }

    startTimer() {
        this.timer = setInterval(this.countDown, 1000);
    }

    countDown() {
        let seconds = this.state.upTime - 1;
        this.setState({upTime: seconds});
        if (seconds <= 0) {
            clearInterval(this.timer);
        }
    }

    handleStartKidSpeak = async () => {
        if(this.props.practice){
            if(typeof newSes !== 'object' && newSes !== null){
                newSes = await JSON.parse(newSes);
            }
            if(typeof bestScor !== 'object' && bestScor !== null){
                bestScor = await JSON.parse(bestScor);
            }
            if(typeof kidspeakTest !== 'object' && kidspeakTest !== null){
                kidspeakTest = await JSON.parse(kidspeakTest);
            }
            await this.setState({
                bestScores: bestScor.body,
                sessionData: newSes,
                ksPassageSrc: kidspeakTest[0].storyStarter,
                ksPassageTitle: kidspeakTest[0].title,
                currentStoryStarter: kidspeakTest[0]
            });
        }
        else {
            await REST.getKSRandom().then(async (res) => {
                let storyStarters = res.body;
                let bestScores = await REST.getBestScores();
                let newSesh = this.state.sessionData;
                newSesh.startLevel = bestScores.body.ksLevel;
                newSesh.startProgress = bestScores.body.ksScore;
                newSesh.passageId = storyStarters[0].id;
                this.setState({
                    bestScores: bestScores.body,
                    sessionData: newSesh,
                    ksPassageSrc: storyStarters[0].storyStarter,
                    ksPassageTitle: storyStarters[0].title,
                    currentStoryStarter: storyStarters[0]
                });
            }).catch(err => {
                console.log(err);
            });
        }
    };

    async handleRecordStart() {
        if (this.state.recordingsCount <= 1) {
            await this.setState({countdown: 3});
            let countDownTimer = setInterval(async () => {
                await this.setState({
                    countdown: this.state.countdown - 1
                });
                if (this.state.countdown < 0) {
                    clearInterval(countDownTimer);
                    this.startRecord();
                }
            }, 1000);
            await this.setState({
                countDownTimer: countDownTimer
            });
        }
    }

    stopRecord() {
        if(this.props.practice){
            this.setState({
                modalDialog: true,
                responseContent: 'Practice Finished'
            });
            setTimeout(() => {
                this.setState({modalDialog: false});
                this.props.buttonClick(0);
            }, 2500);

        }
        else {
            clearTimeout(this.state.audioTimeout);
            clearInterval(this.state.timerInterval);
            this.stopRecordAudio();
            this.setState({
                recording: false,
                isUploading: true
            });
        }
    }

    startRecord() {
        this.startRecordAudio();
        this.setState({
            recording: true
        });
    }

    async recordingAudioPlay() {
        await this.setState({
            recordingAudioPlayCount: this.state.recordingAudioPlayCount + 1
        });
        this.audio2.play();
    }

    render() {

        let countDown = (
            <div hidden={this.state.countdown <= 0}>
                <h1 style={{fontSize: "128pt"}}>{this.state.countdown}</h1>
            </div>
        );

        return (
            <div>
                <div className={!this.props.practice ? "appSection bgGrey" : "appSection bgYellow"}>
                    <div className="container">
                        {
                            !this.props.practice ?
                                <InstructionModals
                                    Kidspeak
                                    modalOpen={this.state.modalInstruction}
                                    instructionMask={videoInstructionPN}
                                    toggleInstruction={this.handleToggleInstruction}
                                    closeClick={(active) => {
                                        this.setState({modalInstruction: active});
                                    }}
                                />
                                : null
                        }
                        <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{
                            if(this.state.noMicroPhone){
                                window.location.reload();
                            }else {
                                this.setState({modalDialog: active, popupSurvey: true});
                            }
                        }} />
                        <div className="row">

                            <div className="appContainer kidspeak">
                                <DialogBox surveyModal app={'KidSpeak'} userId={this.props.studentUser.id} active={this.state.popupSurvey} surveyBack={this.handleSurveyBack}/>
                                <div className="row">

                                    <h2 className={"text-center"}>{this.state.ksPassageTitle}</h2>
                                    <div className="appContainer kidspeak passage">
                                        <div>
                                            {this.state.ksPassageSrc}
                                        </div>
                                        <div className={"row text-center"} style={{paddingTop:"30px"}}>
                                            {countDown}
                                            {
                                                this.state.recording ?
                                                    <div className="rec" style={{position:'relative',top:-20, fontSize:24}}><img src={recButton} className="ico-xs" /> RECORDING </div>
                                                    :
                                                   null
                                            }
                                            <audio ref={audio => {
                                                this.audio = audio
                                            }}/>
                                            <audio
                                                hidden={this.state.recording}
                                                controls={true}
                                                ref={audio2 => {
                                                    this.audio2 = audio2
                                                }}
                                                onPlay={() => this.recordingAudioPlay()}
                                            />
                                        </div>
                                        {this.state.testMode?
                                            <div className={"row text-center"}>
                                                OS Name: {this.state.osName} | Sample Rate HZ: {this.state.sampleRateHz}
                                            </div>:null
                                        }
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>
                <div className="section">
                    <div className="container">
                        <div className="row">
                            <div className="divBottomRelative tr">
                                <div className={"col-md-3 col-sm-4"}></div>
                                <div className={"col-md-6 col-sm-4"}>
                                    <div className={"center-block text-center"} >
                                {/*<a onClick={this.handleBackToMenu}*/}
                                   {/*className="backArrow fl"><span>Back to Home Page</span></a>*/}
                                <a className={this.state.recordingsCount < 1 && !this.state.recording ? "handBtn " : "hidden"}
                                   onClick={this.handleRecordStart}>{this.state.recordingsCount === 0 ? <span>Record</span> : null }</a>
                                <a className={this.state.recording ? "handBtn " : "hidden"}
                                   onClick={this.stopRecord}><span>Stop</span></a>
                                <a className={this.state.audioSrc ? "handBtn " : "hidden"}
                                   onClick={!this.state.disableSubmit ? this.submitSession : null}><span>Finish</span></a>
                                    </div>
                            </div>
                            <div className="col-md-3 col-sm-4">
                            <div className="fr" style={{display: '-webkit-box'}}>
                                <CountDownComponent time={this.state.timerTime} sessionTime={60} showTime={10}/>
                            </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <LoadingModal timer upTime={this.state.upTime}  isUploading={this.state.isUploading}/>
            </div>
        )

    }
}

class Tutorial extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <KidSpeak studentUser={this.props.studentUser} buttonClick={this.props.buttonClick} practice={true}/>
        );
    }
}

const bindActionToProps = dispatch => {
    return {
        updateStudentAppStatus: async(results) => await dispatch(updateStudentAppsStatus(results)),
        updateStudentAccountTab:async(tabNum) => await dispatch(updateStudentAccountTab(tabNum)),
        updateAppStates:async(appStates) => await dispatch(updateAppStates(appStates))
    };
};

const mapStateToProps = state => ({
    apps:state.studentReducer.apps,
    tabNum: state.studentReducer.tabNum,
    studentUser: state.studentReducer.studentUser,
    appStates: state.studentReducer.appStates
});
export default connect(mapStateToProps,bindActionToProps)(withRouter(KidSpeakComponent));



// WEBPACK FOOTER //
// ./src/StudentsComponent/KidSpeak.js